define('views/comments/comment',[
  "globals",
  "../abstract-comments/comment",
  "./comment-form",
  "./reply-form",
  "templates"
], function (globals, AbstractCommentView, CommentFormView, ReplyFormView, JST) {
  "use strict";

  return AbstractCommentView.extend({
    className: "comment",
    template: JST["app/assets/templates/comments/comment.html"],

    $editForm: $("#comment-form"),

    events: {
      "click [data-action = delete]": "destroy",
      "click [data-action = edit]": "edit",
      "click [data-action = reply]": "reply"
    },

    createFormView: function () {
      return new CommentFormView({
        collection: this.collection,
        model: this.model,
        el: $("#comment-form").clone(),
        id: this.model.id
      });
    },

    reply: function (e) {
      e.preventDefault();

      if (this.$el.next("form:visible").length === 0) {
        this.$el.after(new ReplyFormView({
          collection: this.collection,
          model: this.model,
          el: $("#reply-forms").clone(),
          id: this.model.id
        }).render().el);
      }

      return this;
    }
  });
});

